import React, { useEffect } from "react";
import "./OffersPage.css";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import { useSearchParams } from "react-router-dom";
import { setOffers } from "../../../../../store/app/appReducer";
import { useState } from "react";
import callApi from "../../../../../utility/apiCaller";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FileText } from "lucide-react";
import _ from "lodash";

const OfferCard = ({ offer, isExpanded, onExpand }) => {
  const [showDefaultOfferPopup, setShowDefaultOfferPopup] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [showProtiumOfferPopup, setShowProtiumOfferPopup] = useState(false);
  const [isAuthorizedProtium, setIsAuthorizedProtium] = useState(false);
  const [isFinishedProtium, setIsFinishedProtium] = useState(false);
  const user = useSelector((state) => state.app.user);
  const dispatch = useDispatch();
  console.log("user", user);
  const navigate = useNavigate();
  const source = "";
  const token =
    "eyJhbGciOiJSUzI1NiIsImtpZCI6ImE3MWI1MTU1MmI0ODA5OWNkMGFkN2Y5YmZlNGViODZiMDM5NmUxZDEiLCJ0eXAiOiJKV1QifQ.eyJhcHBUeXBlIjoiYXBpX2RpZ2l0bW9uZXkiLCJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20va3JlZGl0YmVlLXN0YWdlIiwiYXVkIjoia3JlZGl0YmVlLXN0YWdlIiwiYXV0aF90aW1lIjoxNzM1NTU5NDM2LCJ1c2VyX2lkIjoiSVhJbmFCSUVtaVFiVlU5Zk12dzY4SzF5MkVyMiIsInN1YiI6IklYSW5hQklFbWlRYlZVOWZNdnc2OEsxeTJFcjIiLCJpYXQiOjE3MzU1NTk0MzYsImV4cCI6MTczNTU2MzAzNiwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6e30sInNpZ25faW5fcHJvdmlkZXIiOiJjdXN0b20ifX0.CigNktWiBhNvgi6pUV9MyKD4eh2AOTtNrn2w54dlORNo2IyhfVAPCJhRT22ZdTdoF-9DldsotvosO8nmlPBfDiUV38JeXO3BxbwBTro-iOt-jdMj_qKm9H86zRrMFjLeQ2Vshgxh6UrVVw3xIMOXE7dTqCssMTG1qBYMBwtQSgGhEXhUxsg6IXADk014VjG-l41mzYPMCxnJjy7ffXszB5h2AfHzP6jdAU2IvhXLMCVw38KjTwLs0id6WbqKMqyyB04R40KVofXkk-1rn3QqO2lSMX8wHhXWSkpe_OQbKbn5gNV7ac8_Kw7MtpGohBdkm9l9N9t6v7VbVDuGBsiv2Q";
  const { _id: leadId, contact_phone: mobile } = useSelector(
    (state) => state.app.lead
  );
  const [params] = useSearchParams();
  const isProtium = offer.lender_id === "662752eb65fdba1a48d6e47c";
  let isanyDataPresent = false;

  const proceedWithProtiumOffer = async () => {
    setUserClickData({
      event_name: `offer-apply-button-${
        params.get("utm_source") || "fb"
      }-default-consent-${offer.lender_name}`,
      user_id: offer.lead_id || "No User ID found",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: params.get("utm_source") || "",
    });
    setUserClickData({
      event_name: `offer-apply-default-button-${
        params.get("utm_source") || "fb"
      }`,
      user_id: offer.lead_id || "No User ID found",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: params.get("utm_source") || "",
    });

    window.location.href = `${offer.app_url}`;
  };

  const handleClick = async () => {
    const offerClicked = [
      `offer-apply-button-${params.get("utm_source") || "fb"}-default-${
        offer.lender_name
      }`,
    ];

    await callApi(
      `v1/lead/${offer.lead_id}/update-lead-new`,
      "post",
      {
        lead: {
          $push: { offers_clicked: { $each: offerClicked } }, // pushes into array
        },
      },
      "core",
      user?.token ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NjA2YWIzNmE1NjE2MjFkNGZiYTllODEiLCJjb250YWN0X25hbWUiOiJNdWt1bCBTaGFybWEiLCJjb3VudHJ5X2NvZGUiOiI5MSIsInBhbmNhcmQiOiJPTFRQUzEyNTVSIiwiY29udGFjdF9waG9uZSI6Ijk2MzQxMDkzNDkiLCJpYXQiOjE3MTE3MTMwNzh9.a0hEtlBumS9YJ9vd0arGJk1feNZjxQ-CwSWx6KcU8ks"
    );

    if (isProtium) {
      setShowProtiumOfferPopup(true);
    } else {
      setUserClickData({
        event_name: `offer-apply-button-${
          params.get("utm_source") || "fb"
        }-default-${offer.lender_name}`,
        user_id: offer.lead_id || "No User ID found",
        affiliate_id: params.get("aff_id") || "No Aff_id found",
      });
      setUserClickData({
        event_name: `offer-apply-default-button-${
          params.get("utm_source") || "fb"
        }`,
        user_id: offer.lead_id || "No User ID found",
        affiliate_id: params.get("aff_id") || "No Aff_id found",
      });
      console.log(`offer.isdefault:${offer.isdefault}`);
      if (offer.isdefault === true) {
        setShowDefaultOfferPopup(true);
      } else {
        console.log(offer.app_url);
        window.location.href = `${offer.app_url}`;
      }
    }
  };

  const proceedWithOffer = async () => {
    setUserClickData({
      event_name: `submit-lead-check-offer-loan-page-${
        params.get("utm_source") || "fb"
      }`,
      user_id: leadId || "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
    });
    try {
      const leadResponse = await callApi(
        "v1/lead/lead-from-phone-nt",
        "post",
        {
          phone: mobile,
          website_kyc_consent: isAuthorized,
          website_kyc_consent_datetime: new Date().toISOString(),
        },
        "core",
        token
      );

      if (leadResponse["status"] === "Success" && leadResponse.data.lead) {
        const leadData = leadResponse.data.lead;

        const ltResponse = await callApi(
          "v1/lender_api_call/list",
          "post",
          {
            filters: {
              lead_id: leadData._id,
              lender_name: "L&T",
            },
            pageSize: 10,
            pageNum: 1,
          },
          "loan_service"
        );

        const coreLeadCheck = await callApi(
          "v1/lead/list",
          "post",
          {
            filters: {
              _id: leadData._id,
            },
          },
          "core"
        );

        const foundLead = coreLeadCheck?.data?.leadList?.[0];
        console.log(
          "foundLead",
          foundLead?._id,
          foundLead?.is_landt_finbud_success
        );
        if (ltResponse?.data?.lender_api_callCount > 0) {
          if (foundLead?.is_landt_finbud_success === true) {
            await fetchOffers(leadData._id);
          }
        } else {
          if (foundLead?.is_landt_finbud_success === true) {
            console.log("Calling bulk-lead-push-by-leadId", {
              leads: [{ lead_id: leadData._id }],
              lender_name: "L&T",
              lender_id: "662752eb65fdba1a48d6e482",
            });
            await callApi(
              "v1/lead/bulk-lead-push-by-leadId-nt",
              "post",
              {
                leads: [{ lead_id: leadData._id }],
                lender_name: "L&T",
                lender_id: "662752eb65fdba1a48d6e482",
              },
              "core",
              token
            );
            await fetchOffers(leadData._id);
          }
        }

        //await fetchOffers(leadData._id);
        // navigate(`/offers?lid=${leadData._id}&source=${source}`);
      } else {
        navigate(`/personal-loan?source=${source}`);
      }
    } catch (error) {
      console.log("Error fetching lead or calling APIs:", error);
      //setIsFinished(true);
      navigate(`/personal-loan?source=${source}`);
    }
  };

  const fetchOffers = async (leadId) => {
    if (!leadId || isFinished) return false;

    try {
      const [offerRes, lenderRes] = await Promise.all([
        callApi(`v1/loan_offer/lead_id/${leadId}`, "get", {}, "core"),
        callApi(`v1/lender/active-lenders`, "get", {}, "loan"),
      ]);

      if (
        offerRes.status === "Success" &&
        offerRes.data?.offers?.length > 0 &&
        lenderRes.status === "Success"
      ) {
        const offers = offerRes.data.offers;
        const apiLenders = lenderRes.data.lenderList ?? [];

        const hardcodedLender = {
          _id: "662752eb65fdba1a48d6e482",
          lender_name: "L&T",
        };
        const mergedLenders = [...apiLenders, hardcodedLender];

        const sortedOffers = _.orderBy(offers, ["priority"], ["asc"]);
        const filteredOffers = sortedOffers.filter((offer) =>
          mergedLenders.some((lender) => lender._id === offer.lender_id)
        );
        const prioritizedOffers = filteredOffers.sort((a, b) => {
          if (a.lender_id === hardcodedLender._id) return -1;
          if (b.lender_id === hardcodedLender._id) return 1;
          return 0;
        });

        dispatch(setOffers(prioritizedOffers));

        setIsFinished(true);
        return true;
      } else {
        setIsFinished(true);
        //navigate(`/offer-page-v3?lid=${leadId}`);
        //dispatch(setOffers([]));
        return false;
      }
    } catch (err) {
      console.error("Error in offer fetching", err);
      toast.error("Something went wrong while fetching offers.");
      setIsFinished(true);
      return false;
    }
  };

  const isLNT = offer.lender_id === "662752eb65fdba1a48d6e482";
  const horizontalLogo = isLNT
    ? "https://campaigns.digitmoney.in/image/partners/lnt.png"
    : offer.banking_partners_hl || offer.logo_image_url;

  const verticalLogo = isLNT
    ? "https://campaigns.digitmoney.in/image/partners/lnt.png"
    : offer.banking_partners_vl || offer.logo_image_url;

  return (
    <>
      {showProtiumOfferPopup && isProtium && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-lg max-h-[90vh] flex flex-col">
            <h2 className="text-xl font-semibold mb-4">
              Do you want to proceed with Protium for a personal loan?
            </h2>

            {/* Scrollable Content */}
            <div
              className="overflow-y-auto pr-2 mb-4 text-sm text-gray-700"
              style={{ maxHeight: "50vh" }}
            >
              <div className="mb-4">
                <p className="mb-2">
                  You are deemed to have full and adequate authority/legal
                  competency to submit the application and relevant documents
                  for availing the loan from Protium Finance Limited
                  (“Protium”).
                </p>
                <p className="mb-2">
                  You authorize Protium or its agents/representatives to use the
                  documents and personal information provided by you to conduct
                  credit reference checks by extracting additional information
                  from various third-party sources (including but not limited
                  to) like credit bureaus, government agencies, banks, CERSAI
                  etc. You authorize Protium to use the same information to
                  conduct further checks for any additional loans in the future
                  and ongoing review. You also authorize Protium to share the
                  application details to other regulated entities or co-lenders
                  at its own discretion.
                </p>
                <p className="mb-2">
                  You authorize Protium for communication with you on any mode
                  (telephone calls/SMS/messaging services like WhatsApp, emails
                  etc.) with respect to revisions in terms & conditions and/or
                  new services/offers from Lender. Further, any acceptance by
                  you from the mobile number(s) and Email ID(s) provided by you
                  will be binding in nature.
                </p>
                <p className="mb-2">
                  You confirm that laws concerning the unsolicited communication
                  referred in “National Do Not Call Registry” (the “NDNC
                  Registry”) will not be applicable for such communication
                  received from Protium and/or associates.
                </p>

                {/* Checkbox moved below */}
                <div className="flex items-start mt-4">
                  <input
                    type="checkbox"
                    id="authorizeCheckbox"
                    className="mt-1 mr-2"
                    checked={isAuthorizedProtium}
                    onChange={(e) => setIsAuthorizedProtium(e.target.checked)}
                  />
                  <label htmlFor="authorizeCheckbox" className="text-gray-700">
                    You confirm to have read and accepted the declaration
                    mentioned at{" "}
                    <a
                      href="https://us-west-2.protection.sophos.com/?d=protium.co.in&u=aHR0cHM6Ly9wcm90aXVtLmNvLmluL3JlZ3VsYXRvcnkvcHJpdmFjeS1wb2xpY3kv&i=NjMwYzkyM2IxNDNlYTYxMjQ3MjQ5YjVm&t=L1BWRi96ek1rMVFlWGkyWjdoVEY1VnpGZnpCWnBmQ3M0MmFEOFdtWXN4OD0=&h=a9ca60c125764c23a95aa51ecc9a1ab3&s=AVNPUEhUT0NFTkNSWVBUSVY5bFm-Ar0_hxsX92H2BJj_Rd6MYRHu-nNvMqLEFWzsJA"
                      className="text-blue-600 underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://us-west-2.protection.sophos.com/?d=protium.co.in&u=aHR0cHM6Ly9wcm90aXVtLmNvLmluL3JlZ3VsYXRvcnkvdGVybXMtYW5kLWNvbmRpdGlvbnMv&i=NjMwYzkyM2IxNDNlYTYxMjQ3MjQ5YjVm&t=UVIra0R0NnNIOG9TUldIUkk4Z0ZBVnB5NEtoUHpnSERWVzZHQmJGekNRZz0=&h=a9ca60c125764c23a95aa51ecc9a1ab3&s=AVNPUEhUT0NFTkNSWVBUSVY5bFm-Ar0_hxsX92H2BJj_Rd6MYRHu-nNvMqLEFWzsJA"
                      className="text-blue-600 underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      T&amp;C
                    </a>
                    .
                  </label>
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex justify-end space-x-3 mt-auto">
              <button
                className="bg-gray-300 px-4 py-2 rounded"
                onClick={() => setShowProtiumOfferPopup(false)}
              >
                Cancel
              </button>
              <button
                className={`px-4 py-2 rounded text-white ${
                  isAuthorized
                    ? "bg-blue-600"
                    : "bg-blue-300 cursor-not-allowed"
                }`}
                disabled={!isAuthorized}
                onClick={() => {
                  setShowProtiumOfferPopup(false);
                  proceedWithProtiumOffer();
                }}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}
      {showDefaultOfferPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-lg">
            <h2 className="text-xl font-semibold mb-4">
              Do you want to proceed with L&T for a personal loan?
            </h2>

            <div className="flex items-start mb-4">
              <input
                type="checkbox"
                id="authorizeCheckbox"
                className="mt-1 mr-2"
                checked={isAuthorized}
                onChange={(e) => setIsAuthorized(e.target.checked)}
              />
              <label htmlFor="authorizeCheckbox" className="text-gray-700">
                You authorize us to share your details with L&T to obtain your
                credit information for generating the loan offer.
              </label>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                className="bg-gray-300 px-4 py-2 rounded"
                onClick={() => setShowDefaultOfferPopup(false)}
              >
                Cancel
              </button>
              <button
                className={`px-4 py-2 rounded text-white ${
                  isAuthorized
                    ? "bg-blue-600"
                    : "bg-blue-300 cursor-not-allowed"
                }`}
                disabled={!isAuthorized}
                onClick={() => {
                  setShowDefaultOfferPopup(false);
                  proceedWithOffer();
                }}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="offer-card-section">
        <div
          className={`offer-card ${isExpanded ? "expanded-v5" : "collapsed"}`}
          onClick={onExpand}
        >
          {isExpanded && (
            <>
              <img src={horizontalLogo} className="lender-logo" alt="Lender" />
            </>
          )}

          <div className="offer-details">
            {isExpanded && <hr className="offer-divider" />}

            {isExpanded ? (
              <>
                <div className="amount-row">
                  <span className="amount-label1">
                  {["69a2c7ab1f6f4ddfd5577314", "69ea0b864084a68bdadc40bd", "6a2818d365c271100d17551e"].includes(offer.lender_id)
                    ? "Gold Loan Amount:"
                    : offer.lender_id === "69a1d3801f6f4ddfd55732ed"
                    ? "Credit Line Amount:"
                    : [
                        "662752eb65fdba1a48d6e466",
                        "666ec1953a9a969d8f9980f1",
                        "67762d497ae263a3ec86347e",
                        "6799b8fada60414f0f195bf9",
                        "67bd3abe694463207380f33d",
                        "67be8fc6049b9a4e3af8191a",
                        "67e23d6fe162ba8f717ec5bf",
                        "67ef646df80610d286084e60",
                        "68401febe871a7a9504dc2e3",
                        "69dd0df04d3185176dd02d27",
                      ].includes(offer.lender_id)
                    ? "Max Loan Amount:"
                    : "Pre-Approved Amount:"}
                  </span>
                  <span className="amount-value">
                    {" "}
                    upto ₹{offer.credit_limit}
                  </span>
                </div>
              </>
            ) : (
              <div className="amount-row">
                <img src={verticalLogo} className="lender-logo" alt="Lender" />
                <div>
                  <span className="amount-label">{"Max Loan Amount: "}</span>
                  <br />
                  <span className="amount-value">
                    {" "}
                    upto ₹{offer.credit_limit}
                  </span>
                </div>
              </div>
            )}

            {isExpanded && <hr className="offer-divider" />}
            {isExpanded && (
              <>
                {!offer.isdefault && (
                  <>
                    {offer.lender_id === "69a2c7ab1f6f4ddfd5577314" ? (
                      <div className="emi-row">
                        Your details have been shared with the IIFL. Someone from IIFL team will
                        contact you within the next 24–48 hours.
                      </div>
                    ) : offer.lender_id === "69ea0b864084a68bdadc40bd" ? (
                      <div className="emi-row">
                        Your details have been shared with the Muthoot Finance. Someone from Muthoot team will
                        contact you within the next 24–48 hours.
                      </div>
                    ) : offer.lender_id === "6a2818d365c271100d17551e" ? (
                      <div className="emi-row">
                        Your details have been shared with the Manipal Fintech. Someone from their team will
                        contact you within the next 24–48 hours.
                      </div>
                    ) : (
                      <div className="emi-row">
                        Tenure: {offer.tenure || 48} Months
                      </div>
                    )}
                    {isExpanded && <hr className="offer-divider" />}
                    {offer.interest_rate && (
                      <>
                        <span className="emi-row">
                          Interest Rate: {offer.interest_rate}
                        </span>
                      </>
                    )}

                    {isExpanded && <hr className="offer-divider" />}
                    {offer.processing_fee && (
                      <div className="w-full text-center pb-2">
                        <span className="emi-row">
                          Processing Fees: {offer.processing_fee}
                        </span>
                      </div>
                    )}
                  </>
                )}
                {isExpanded && offer.processing_fee && (
                  <hr className="offer-divider" />
                )}

                <div className="loan-extra-details mt-3 text-sm text-gray-700">
                  {offer.apr && (
                    <div className="flex justify-between mb-1 font-semibold">
                      <span className="font-semibold text-gray-800">APR:</span>
                      <span>{offer.apr}</span>
                    </div>
                  )}

                  {offer.penal_charges && (
                    <div className="flex justify-between mb-1 font-semibold">
                      <span className="font-semibold text-gray-800">
                        Penal Charges:
                      </span>
                      <span>{offer.penal_charges}</span>
                    </div>
                  )}

                  {offer.kfs_doc && (
                    <div className="flex items-center justify-between mt-2 font-semibold">
                      <span className=" text-gray-800 font-semibold">
                        View KFS:
                      </span>
                      <a
                        href={offer.kfs_doc}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center text-green-700 font-semibold hover:underline"
                      >
                        <FileText className="w-4 h-4 mr-1" />
                        Document
                      </a>
                    </div>
                  )}
                </div>

                <button
                  className="get-offer-btn tracking-get-offer-btn-v5"
                  // id={`btn-get-offer-${
                  //   offer.lender_name?.toLowerCase().replace(/\s+/g, "-") ||
                  //   "unknown"
                  // }-v5`}
                  id={`btn-get-offer-v5`}
                  onClick={handleClick}
                >
                  {" "}
                  Get Offer{" "}
                  <img
                    src="/assets/img/Get offer CTA icon.svg"
                    alt="Arrow"
                    className="cta-icon"
                  />
                </button>
              </>
            )}
          </div>

          {!isExpanded && (
            <img
              src="/assets/img/offers arrow.svg"
              className="collapse-arrow"
              alt="Expand"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default OfferCard;
